"use client";

import React from "react";
import { Link } from "@/components/common/Link";
const artForms = [{
  id: 1,
  title: "視覺藝術",
  englishTitle: "Visual Arts",
  description: "透過色彩與線條，捕捉那些無法言說的內在風景。",
  image: "https://dearexa.com/wp-content/uploads/2026/06/WhatsApp-Image-2026-05-25-at-14.58.43-1-1-scaled.png?v=cc4hzbvadam",
  srcset: "https://dearexa.com/wp-content/uploads/2026/06/WhatsApp-Image-2026-05-25-at-14.58.43-1-1-scaled.png?v=b104yglxuyf-wvc-srcset",
  sizes: "https://dearexa.com/wp-content/uploads/2026/06/WhatsApp-Image-2026-05-25-at-14.58.43-1-1-scaled.png?v=731ouyyou6j-wvc-sizes",
  link: "/ImageAndCreationVisualExpressionPage"
}, {
  id: 2,
  title: "身體與律動",
  englishTitle: "Movement",
  description: "讓身體成為容器，在呼吸與舞動間釋放情感。",
  image: "https://dearexa.com/wp-content/uploads/2026/06/WhatsApp-Image-2026-05-25-at-15.10.56.jpeg?v=a9pdx2kp46",
  srcset: "https://present-impala.10web.cloud/wp-content/uploads/2026/05/1779893088287.png?v=tigu1j804p-wvc-srcset",
  sizes: "https://present-impala.10web.cloud/wp-content/uploads/2026/05/1779893088287.png?v=wfhkj1lfjy-wvc-sizes",
  link: "/BodySensoryMovementSomaticAwarenessPage"
}, {
  id: 3,
  title: "音樂與聲音",
  englishTitle: "Music & Sound",
  description: "在旋律與節奏中，尋找心靈最深處的共鳴。",
  image: "https://dearexa.com/wp-content/uploads/2026/06/20250627_142746-scaled.jpg?v=jykjbydy25k",
  srcset: "https://dearexa.com/wp-content/uploads/2026/06/20250627_142746-scaled.jpg?v=w7i0mh6z29-wvc-srcset",
  sizes: "https://dearexa.com/wp-content/uploads/2026/06/20250627_142746-scaled.jpg?v=qc1b6du1cd-wvc-sizes",
  link: "/SoundAndRhythmMusicSoundPage"
}, {
  id: 4,
  title: "戲劇與角色",
  englishTitle: "Drama",
  description: "透過扮演與敘事，重新看見生命的多元可能。",
  image: "https://dearexa.com/wp-content/uploads/2026/05/Gemini_Generated_Image_22zyl122zyl122zy-e1779908958591.png?v=ctp46kpl9e",
  srcset: "https://dearexa.com/wp-content/uploads/2026/05/Gemini_Generated_Image_22zyl122zyl122zy-e1779908958591.png?v=mga3ju5wrce-wvc-srcset",
  sizes: "https://dearexa.com/wp-content/uploads/2026/05/Gemini_Generated_Image_22zyl122zyl122zy-e1779908958591.png?v=q6xv04otube-wvc-sizes",
  link: "/StoryAndCharactersDramaNarrativeExplorationPage"
}, {
  id: 5,
  title: "文字與書寫",
  englishTitle: "Creative Writing",
  description: "以筆尖梳理思緒，將破碎的感悟凝結成詩。",
  image: "https://dearexa.com/wp-content/uploads/2026/06/WhatsApp-Image-2026-06-04-at-22.13.21-1.jpeg?v=s7szjal4t1d",
  srcset: "https://dearexa.com/wp-content/uploads/2026/05/image-2.png?v=xfty8m17hlc-wvc-srcset",
  sizes: "https://dearexa.com/wp-content/uploads/2026/05/image-2.png?v=bj4tsks8ivi-wvc-sizes",
  link: "/WritingAndReflectionPage"
}];
function ArtFormsGrid() {
  return <div className="grid grid-cols-1 gap-x-12 gap-y-24 md:grid-cols-2 lg:grid-cols-12">
      {artForms.map((item, i) => {
      const colSpan = i === 0 ? "lg:col-span-6" : i === 1 ? "lg:col-span-3" : i === 2 ? "lg:col-span-3" : i === 3 ? "lg:col-span-6" : "lg:col-span-6";
      const aspectClass = i === 0 ? "aspect-[16/10]" : "aspect-[4/5]";
      return <div key={item.id} data-index={i} className={`group flex flex-col ${colSpan} transition-all duration-1000 ease-in-out`}>
            <div className="relative mb-8 overflow-hidden rounded-lg bg-card transition-colors duration-700 group-hover:bg-secondary/20">
              <Link to={item.link} className="block h-full w-full">
                <div className={`${aspectClass} w-full overflow-hidden`}>
                  <img src={item.image} data-wvc-srcset={item.srcset} data-wvc-sizes={item.sizes} alt={item.title} className="h-full w-full object-cover transition-transform duration-1000 ease-out group-hover:scale-105" loading="lazy" decoding="async" />
                </div>
              </Link>
              
              <div className="absolute inset-0 flex items-center justify-center bg-background/10 opacity-0 backdrop-blur-[2px] transition-all duration-500 ease-in-out group-hover:opacity-100">
                <Link to={item.link} className="rounded-lg bg-primary px-8 py-3 font-sans text-[10px] uppercase tracking-[0.2em] text-primary-foreground shadow-md transition-all hover:bg-primary/90">
                  探索 Explore
                </Link>
              </div>
            </div>

            <div className="flex flex-col space-y-3 px-2">
              <div className="flex items-center justify-between">
                <Link to={item.link} className="block">
                  <h3 className="font-serif text-xl font-medium tracking-tight text-foreground transition-colors duration-300 group-hover:text-primary md:text-2xl">
                    {item.title}
                  </h3>
                </Link>
                <span className="font-mono text-[10px] text-muted-foreground/40">0{i + 1}</span>
              </div>
              
              <div className="h-px w-12 bg-primary/20 transition-all duration-700 group-hover:w-20 group-hover:bg-primary/60" />
              
              <div className="space-y-2">
                <p className="font-sans text-[10px] font-semibold uppercase tracking-[0.25em] text-primary/70">
                  {item.englishTitle}
                </p>
                <p className="max-w-xs font-sans text-xs leading-relaxed text-muted-foreground/60">
                  {item.description}
                </p>
              </div>
            </div>
          </div>;
    })}
    </div>;
}
export default function FiveLanguagesOfArt() {
  return <section data-section-id="257293" id="五種藝術語言-five-languages-of-art" className="relative overflow-hidden bg-background py-32 md:py-48">
      <div className="pointer-events-none absolute inset-0 z-0 opacity-40">
        <div className="absolute top-[20%] -left-[5%] h-[600px] w-[600px] rounded-lg bg-primary/5 blur-[140px]" />
        <div className="absolute bottom-[10%] -right-[5%] h-[500px] w-[500px] rounded-lg bg-secondary/10 blur-[120px]" />
      </div>

      <div className="container relative z-10 mx-auto px-6 lg:px-16">
        <div className="mb-24 flex flex-col items-start md:mb-32 md:flex-row md:items-end md:justify-between">
          <div className="max-w-2xl">
            <span className="mb-6 block font-sans text-[11px] font-bold uppercase tracking-[0.4em] text-primary">
              Modality
            </span>
            <h2 className="mb-6 font-serif text-4xl font-semibold tracking-tight text-foreground md:text-5xl lg:text-6xl">
              五種藝術語言
            </h2>
            <p className="font-serif text-xl italic text-muted-foreground/70">
              Five Languages of Art
            </p>
          </div>
          
          <div className="mt-12 hidden h-px flex-1 bg-border/40 md:mx-12 md:mb-6 md:block" />
          
          <div className="mt-8 max-w-xs md:mt-0">
            <p className="font-sans text-xs leading-relaxed tracking-wide text-muted-foreground/60">
              透過不同的藝術媒介，我們尋找那些無法言說的感受，讓創作成為心靈的出口。
            </p>
          </div>
        </div>

        <ArtFormsGrid />

        <div className="mt-32 flex flex-col items-center justify-center space-y-8 text-center md:mt-48">
          <div className="h-16 w-px bg-primary/20" />
          <blockquote className="mx-auto max-w-2xl">
            <p className="font-serif text-lg leading-relaxed italic text-muted-foreground/80 md:text-xl">
              "In the space between what is said and what is felt, art becomes the bridge."
            </p>
            <footer className="mt-4 font-sans text-[10px] uppercase tracking-[0.3em] text-primary/60">
              — The Creative Process
            </footer>
          </blockquote>
        </div>
      </div>
    </section>;
}